import { AVAILABILITY_BADGE_COLORS } from 'src/models/inventory-strategy/InventoryStrategy'
import availabilitiesAndConstraintsService from 'src/services/inventory/sales-restrictions/AvailabilitiesAndConstraintsService'
import availableStockService from 'src/services/inventory/sales-restrictions/AvailableStockService'
import { getInventoryStrategy } from 'src/services/inventory/sales-restrictions/helpers'
import isOutOfStockService from 'src/services/inventory/sales-restrictions/IsOutOfStockService'

class AvailabilityBadgeColorService {
  static #instance = null

  static #availabilitiesAndConstraintsService = null
  static #availableStockService = null
  static #isOutOfStockService = null

  constructor ({
    availabilitiesAndConstraintsService,
    availableStockService,
    isOutOfStockService
  }) {
    if (!AvailabilityBadgeColorService.#instance) {
      AvailabilityBadgeColorService.#availabilitiesAndConstraintsService = availabilitiesAndConstraintsService
      AvailabilityBadgeColorService.#availableStockService = availableStockService
      AvailabilityBadgeColorService.#isOutOfStockService = isOutOfStockService

      AvailabilityBadgeColorService.#instance = this
    }
    return AvailabilityBadgeColorService.#instance
  }

  availabilityBadgeColor (model, options) {
    const inventoryStrategy = getInventoryStrategy()

    if (_.isNil(inventoryStrategy)) return null

    if (!AvailabilityBadgeColorService.#availabilitiesAndConstraintsService.isModelInventoriable(model)) return null

    if (AvailabilityBadgeColorService.#isOutOfStockService.isOutOfStock(model, options)) return AVAILABILITY_BADGE_COLORS.NEGATIVE

    if (AvailabilityBadgeColorService.#availableStockService.availableStock(model, options) < inventoryStrategy.availabilityBadgeLowStockThreshold) return AVAILABILITY_BADGE_COLORS.WARNING

    return AVAILABILITY_BADGE_COLORS.POSITIVE
  }
}

const availabilityBadgeColorService = new AvailabilityBadgeColorService({
  availabilitiesAndConstraintsService,
  availableStockService,
  isOutOfStockService
})

export default availabilityBadgeColorService
